// extracted by mini-css-extract-plugin
export var hideEditor = "_mx-2";
export var infoIcon = "_mx-3";
export var label = "_mx-1";
export var labelContainer = "_mx-0";
export var readonlyText = "_mx-4";